import { all } from "redux-saga/effects";

import certificateSaga from "./certificate/certificateSaga";

export default function* rootSaga() {
  yield all([...certificateSaga]);
}
